import { QuestionComponentValue } from '@wix/answers-api';
import { ArticleViewer as KbArticleViewer, ArticleViewerProps } from '@wix/kb-article-viewer';
import React, { FC, useCallback, useRef } from 'react';

import { classNames } from '../../../../util';
import { getThemeTraits } from '../../../util/widgetTheme';
import s from './custom-html-block-styles.scss';
// for cases, when css should be different in preview and in full view
export enum ArticleView {
  PREVIEW = 'CHATBOT_ARTICLE_PREVIEW',
  FULL = 'CHATBOT_ARTICLE_FULL',
}

export const ArticleViewer: FC<ArticleViewerProps & { chatbotArticleView: ArticleView }> = (props) => {
  const containerRef = useRef<HTMLDivElement>(null);

  const onLinkClick = useCallback(
    (e: MouseEvent, href: string) => {
      if (!props.onLinkClick || !containerRef.current) {
        return;
      }

      if (containerRef.current.contains(e.target as Node)) {
        props.onLinkClick(e, href);
      }
    },
    [props],
  );

  const onQuestionClick = useCallback(
    (question: QuestionComponentValue) => {
      if (!props.onQuestionClick) {
        return;
      }
      props.onQuestionClick(question);
    },
    [props],
  );

  return (
    <div
      ref={containerRef}
      className={classNames([
        s.articleViewer,
        props.chatbotArticleView === ArticleView.FULL && s.chatbotArticleFull,
        props.chatbotArticleView === ArticleView.PREVIEW && s.chatbotArticlePreview,
      ])}
    >
      <KbArticleViewer
        {...props}
        onLinkClick={onLinkClick}
        onQuestionClick={onQuestionClick}
        theme="helpcenter"
        darkTheme={getThemeTraits().dark}
      />
    </div>
  );
};
